module.exports = __webpack_public_path__ + "img/xuanfushan copy.49dfc2f5.png";